const projects = [
  {
    tag: 'PLATFORM',
    name: 'LAWET',
    desc: 'End-to-end product development.\nFrom concept to live platform.',
  },
  {
    tag: 'PRODUCT DEVELOPMENT',
    name: 'CLIENT\nSYSTEMS',
    desc: 'Custom business systems built\nfor scale and reliability.',
  },
  {
    tag: 'AUTOMATION',
    name: 'INTERNAL\nTOOLS',
    desc: 'Workflow automation and\ninternal tooling that saves hours.',
  },
];

export default function ProjectsSection() {
  return (
    <section className="section section--divider" id="work">
      <div className="section__label">06 — PROJECTS</div>

      <h2 className="projects__big">BUILT.</h2>

      <div className="projects__grid">
        {projects.map((p) => (
          <div className="project-card" key={p.name}>
            <div className="project-card__tag">{p.tag}</div>
            <div className="project-card__name" style={{ whiteSpace: 'pre-line' }}>
              {p.name}
            </div>
            <div className="project-card__desc" style={{ whiteSpace: 'pre-line' }}>
              {p.desc}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
